import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import Back from "../../../../components/back-btn/back-btn";
import MainButton from "../../../../components/button/button";
import PageTitle from "../../../../components/page-title/page-title";
import { Edit } from "@mui/icons-material";
import { UseTrademarkAPI } from "../../../../services/use-trademark";
import { OperationsAPI } from "../../../../services/operations";
import { CityAPI } from "../../../../services/city";
import { handleResponseStatus } from "../../../../utils/handle-response-status";
import {
  setClearErrorAction,
  setStatusText,
} from "../../../../store/use-trademark/slice";
import { setImageSlice } from "../../../../store/image/slice";
import Form from "../../../../components/forms/use-trademark/form";

const EditUseTrademark = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { oneUseTrademark, status, errorStatus } = useSelector(
    (state) => state.useTrademark
  );
  const { image } = useSelector((state) => state.image);
  const { listFile } = useSelector((state) => state.file);

  const { control, handleSubmit, watch, reset } = useForm({
    defaultValues: {
      ...oneUseTrademark,
    },
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const updatedData = {
        ...data,
        image,
        upload_file: data.upload_file.map((item, index) => {
          const file = listFile[index]?.file || item.file;
          return { ...item, file };
        }),
      };

      await dispatch(UseTrademarkAPI.update(updatedData)).unwrap();
    } catch (error) {
      console.error("Update failed:", error);
    }
  });

  useEffect(() => {
    (async () => {
      try {
        await Promise.all([
          dispatch(UseTrademarkAPI.getOne(id)).unwrap(),
          dispatch(CityAPI.getCities()).unwrap(),
          dispatch(OperationsAPI.getTrademarkObjectionList()).unwrap(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [dispatch, id]);

  useEffect(() => {
    if (oneUseTrademark) {
      reset(oneUseTrademark);
      dispatch(setImageSlice(oneUseTrademark.image));
    }
  }, [dispatch, reset, oneUseTrademark]);

  useEffect(() => {
    handleResponseStatus({
      status,
      errorStatus,
      dispatchActions: [{ action: dispatch, payload: setStatusText(null) }],
      successMessage: "Տվյալները հաջողությամբ փոփոխված են",
      navigatePath: "/use-trademark",
      navigate,
      errorMessage: errorStatus,
      clearErrorAction: () => dispatch(setClearErrorAction()),
    });
  }, [status, errorStatus, dispatch, navigate]);

  return (
    <>
      <Back />
      <PageTitle title="Փոխել տվյալները" />
      <Form control={control} watch={watch} />
      <MainButton
        type="submit"
        onClick={onSubmit}
        variant="contained"
        startIcon={<Edit />}
      >
        Փոխել տվյալները
      </MainButton>
    </>
  );
};

export default EditUseTrademark;
